import React, { useState, useEffect, useCallback, useMemo } from "react"
import { useNavigate } from "react-router-dom";
import { Button, Popover, Select } from 'antd';
import { Table, Modal } from 'antd';
import images from '../../themes/appImage'
import { useDispatch, useSelector } from "react-redux";
import { accountStatusLoad, coreValueLoad, userListLoad } from "../../redux/slices/user.slice";
import { imageURL } from "../../redux/Api/apikit";
import { debounce } from "../../utils/global-func";
import moment from "moment";
import CoreValueGraph from "./coreValueGraph";
import { convertToTitleCase, emptySpaceInputHandler } from "../../utils";

const numberOfRowOptionList = [
    { value: 'one', label: 10 },
    { value: 'two', label: 20 },
    { value: 'three', label: 25 },
]

let LIST_LIMIT = 10
let OFFSET = 0

let currentSortValue = -1
let sort = "createdAt"
const userListPayload = {
    "offset": 0,
    "limit": 10,
    "search": "",
    "sort": sort,
    "order": currentSortValue
}

const Users = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { accountStatusData, coreValueData, userListData } = useSelector(state => state.userReducer)
    let coreValueData_Correction = coreValueData ? Object?.keys(coreValueData?.cores || {})?.map(key => ({
        text: key,
        value: coreValueData?.cores[key]
    })) : [];
    const [modal2Open, setModal2Open] = useState(false)
    const [modal3Open, setModal3Open] = useState(false)
    const [search, setSearch] = useState("")

    useEffect(() => {
        dispatch(accountStatusLoad())
        dispatch(coreValueLoad())
        dispatch(userListLoad(userListPayload))
    }, [])

    const columns = [
        {
            title: 'ID',
            dataIndex: 'srno',
            key: 'srno',
            sorter: false,
            render: (value, item, index) => (OFFSET + index + 1)
        },
        {
            title: 'Full Name',
            dataIndex: 'name',
            key: 'name',
            sorter: false,
            sortDirections: ['ascend', 'descend'],
            title: () => {
                return (
                    <div onClick={() => sortHandler("firstName")} className="sort-icons cursor-pointer">
                        <span>Full Name</span> <img src={images.arrowLeft} alt="" />
                    </div>
                );
            },
            render: (value, item, index) => <div className="organization-image-sec">
                {item.avatar && <span><img className="w-6 h-6 rounded-[100%] object-contain" src={`${imageURL}${item.avatar}`} /></span>}
                {item.firstName}  {item.lastName}
            </div>
        },
        {
            title: 'Username',
            dataIndex: 'userName',
            key: 'userName',
            sorter: false,
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            sorter: false,
        },
        {
            title: 'Gender',
            dataIndex: 'identityType',
            key: 'gender',
            sorter: false,
            sortDirections: ['ascend', 'descend'],
            title: () => {
                return (
                    <div className="sort-icons">
                        <span>Gender</span> <img src={images.arrowLeft} alt="" />
                    </div>
                );
            },


        },
        {
            title: 'DOB',
            dataIndex: 'dob',
            key: 'dob',
            sorter: false,
            render: (value, item, index) =>
                <div className="table-tb-plan">
                    {item.dob ? moment(item.dob).format('MMMM D, YYYY') : "N/A"}
                </div>
        },
        {
            title: 'Visibility',
            dataIndex: 'isPrivate',
            key: 'isPrivate',
            sorter: false,
            render: (value, item, index) => <div className="organization-image-sec">
                {item.isPrivate.toString()}
            </div>
        },
        {
            title: 'Badges',
            dataIndex: 'badges',
            key: 'badges',
            sorter: false,
            render: (value, item, index) => <div className="organization-image-sec">
                {item.badges} <span><img src={images.fluentInfo} /></span>
            </div>
        },
        {
            title: 'Organizations',
            dataIndex: 'badges',
            key: 'badges',
            sorter: false,
            render: (value, item, index) => <div className="organization-image-sec">
                {item?.inOrg ? convertToTitleCase(item?.inOrg.name) : "N/A"}
            </div>
        },
        {
            title: 'Paid User',
            dataIndex: 'badges',
            key: 'badges',
            sorter: false,
            render: (value, item, index) => <div className="organization-image-sec">
                {(item?.isPaid || item?.inOrg) ? "Paid" : "Un-Paid"}
            </div>
        },
        {
            title: 'Coins',
            dataIndex: 'coin',
            key: 'coin',
            sorter: false,
            sortDirections: ['ascend', 'descend'],
            title: () => {

                return (
                    <div
                        onClick={() => sortHandler("coin")}
                        className="sort-icons cursor-pointer">
                        <span>Coins</span> <img src={images.arrowLeft} alt="" />
                    </div>
                );
            },


        },
        {
            title: 'Action',
            dataIndex: 'Posted',
            key: 'Posted',
            render: (value, item, index) => {
                return (

                    <Popover
                        content={
                            <Button
                                type="text"
                                onClick={() => {
                                    navigate('/addusers', { state: { userId: item._id } })
                                }}
                            >
                                View
                            </Button>
                        }
                        trigger="click"
                    >
                        <div className="relative action-dots-iocn">
                            <span>
                                <img src={images.horizontalDots} />
                            </span>
                        </div>
                    </Popover>
                )
            }
        },
    ];

    // P A G I N A T I O N 

    // --S T A T E--
    const START = useMemo(() => OFFSET + 1, [userListData.userList]);
    const TOTAL_LIST_ITEMS = useMemo(() => userListData.pagination?.totalCount, [userListData.userList])
    const END = useMemo(() => (Math.min(OFFSET + LIST_LIMIT, TOTAL_LIST_ITEMS)), [userListData.userList]);
    const canCallNextData = OFFSET + LIST_LIMIT < TOTAL_LIST_ITEMS

    // --A C T I O N S--
    const paginationHandler = useCallback((type) => {
        if (type === "pre") {
            OFFSET = OFFSET - LIST_LIMIT
            const data = {
                offset: OFFSET,
                limit: LIST_LIMIT,
                search: search,
                sort: sort,
                order: currentSortValue
            }
            dispatch(userListLoad(data));
        } else {
            OFFSET = OFFSET + LIST_LIMIT
            const data = {
                offset: OFFSET,
                limit: LIST_LIMIT,
                search: search,
                sort: "createdAt",
                order: -1
            }
            dispatch(userListLoad(data));
        }
    }, [userListData.userList])

    const numberOfRowHandler = useCallback((ddateStringate, dataObj) => {
        LIST_LIMIT = dataObj.label
        OFFSET = 0
        const data = {
            offset: OFFSET,
            limit: LIST_LIMIT,
            search: search,
            sort: sort,
            order: currentSortValue
        }
        dispatch(userListLoad(data));
    }, [userListData.userList])

    const searchHandler = useCallback((e) => {
        if (emptySpaceInputHandler(e) || e.target.value.length == "") {
            LIST_LIMIT = 10
            OFFSET = 0
            setSearch(emptySpaceInputHandler(e))
            const data = {
                offset: 0,
                limit: 10,
                search: emptySpaceInputHandler(e).trim(),
                sort: "createdAt",
                order: -1
            }
            debounce(() => dispatch(userListLoad(data)))
        }
    }, [userListData.userList]);

    const sortHandler = useCallback((sort) => {

        currentSortValue = currentSortValue == -1 ? 1 : -1
        const data = {
            offset: OFFSET,
            limit: LIST_LIMIT,
            search: search,
            sort: sort,
            order: currentSortValue
        }
        dispatch(userListLoad(data));
    }, [userListData.userList])


    return (
        <div>
            <div className="site-layout-background" style={{ minHeight: 360 }}>
                <div className="top-header-organi-zations">
                    <div className="organi-zations-heading-text">
                        <h1>Users</h1>
                        {/* <p>Sed consectetur imperdiet facilisiulla malesua daeddiet facilisiulla</p> */}
                    </div>
                    {/* Version 2 */}
                    {/* <div className="add-new-button user-page-btn">
                        <button >Freeze Profile</button>
                        <button >Remove Profile</button>
                    </div> */}
                </div>

                <div className="total-user">
                    <div className="user-count">
                        <p>Total Users</p>
                        <h1>{TOTAL_LIST_ITEMS}</h1>
                    </div>
                    <div className="user-count visibility-bar">
                        <p>Visibility Preference</p>
                        <div className=" flex mt-2 w-full h-[9.9px] rounded-full overflow-hidden border border-r">
                            <div className={`h-full`}
                                style={{
                                    width: String(accountStatusData.isPrivateFalse) + "%",
                                    backgroundColor: "#7c63a4"
                                }}
                            />
                            <div className={`h-full`}
                                style={{
                                    width: String(accountStatusData.isPrivateTrue) + "%",
                                    backgroundColor: "#f16480"
                                }}
                            />
                        </div>
                        <div className="pub-pri">
                            <h6><p></p> Public </h6>
                            <h6><p className="new-color"></p> Private </h6>
                        </div>
                    </div>
                    <div className="user-count core-values">
                        <div className="core-flex">
                            <p>Core Values</p>
                            <span onClick={() => setModal3Open(true)}>View all </span>
                        </div>
                        <div className=" flex mt-2 w-full h-[9.9px] rounded-full overflow-hidden border border-r">
                            <div className={`h-full`}
                                style={{
                                    width: String(coreValueData?.Acceptance) + "%",
                                    backgroundColor: "#7c63a4"
                                }}
                            />
                            <div className={`h-full`}
                                style={{
                                    width: String(coreValueData?.Beauty) + "%",
                                    backgroundColor: "#f16480"
                                }}
                            />
                            <div className={`h-full`}
                                style={{
                                    width: String(coreValueData?.Caring) + "%",
                                    backgroundColor: "#d6a2be"
                                }}
                            />
                        </div>
                        <div className="pub-pri">
                            <h6><p></p> Acceptance </h6>
                            <h6><p className="new-color"></p> Beauty </h6>
                            <h6><p className="new-pink-color"></p> Caring </h6>
                        </div>
                    </div>
                    {/* Version 2 */}
                    {/* <div className="user-count things-values">
                        <div className="core-flex">
                            <p>Things People would like to work on most</p>
                            <span onClick={() => setModal2Open(true)}>View all </span>
                        </div>
                        <div className="progress-bar add-bg-color">
                            <Progress percent={100} />
                        </div>
                        <div className="pub-pri">
                            <h6><p></p> Meditation </h6>
                            <h6><p className="new-color"></p> Well-being tracking </h6>
                            <h6><p className="new-pink-color"></p> Mindfulness </h6>
                            <h6><p className="new-text-color"></p> Sleep </h6>
                        </div>
                    </div> */}
                </div>

                <div className="content-e">
                    <div class="bg-gradient-primary  system-line">
                        <input type="text" value={search} onChange={searchHandler} className="iocn-search  search-bar" placeholder="Search User" />
                        {/* Version 2 */}
                        {/* <div className="top-checkbox">
                            <Select
                                defaultValue="Select Plan"
                                onChange={monthHandler}
                                options={monthOptionsList}
                            />
                        </div> */}
                    </div>

                    <Table
                        dataSource={userListData?.userList}
                        columns={columns}
                        showSorterTooltip={false}
                        pagination={{
                            current: 0,
                            pageSize: 0,
                            total: TOTAL_LIST_ITEMS,
                        }}
                    />

                    {TOTAL_LIST_ITEMS > 10 && <div className="footer-section">
                        <div className="foot-main-div">
                            <div className="rows">
                                <div className="row-per-page">
                                    <p>Rows per page</p>
                                </div>

                                <div className="top-checkbox fot-select">
                                    <Select
                                        defaultValue={LIST_LIMIT}
                                        onChange={numberOfRowHandler}
                                        options={numberOfRowOptionList}
                                    />
                                </div>
                            </div>

                            <div className="page-count">
                                <p>{`${START}-${END} of ${TOTAL_LIST_ITEMS}`}</p>
                            </div>

                            <div className="back-and-next">
                                {/* <span><img src={images.back} alt="back" /></span> */}
                                <span onClick={() => OFFSET !== 0 && paginationHandler("pre")}><img src={OFFSET == 0 ? images.per : images.paginationDimLeft} style={{ tintColor: "red" }} alt="back" /></span>
                                <span onClick={() => canCallNextData && paginationHandler("next")}><img src={canCallNextData == false ? images.paginationDimRight : images.new} alt="back" /></span>
                                {/* <span><img src={images.next} alt="back" /></span> */}
                            </div>

                        </div>

                    </div>}
                </div>
            </div>

            <Modal
                title=""
                className="modal-update create-modal"
                centered
                visible={modal2Open}
                closable={true}
                onCancel={() => setModal2Open(false)}
                footer={false}
                width={600}  >
                <div className="add-user-popup">
                    <div className="modal-add-user things-people">
                        <h1>Things People Would Like to Work on Most</h1>
                    </div>

                    <div className="create-metail-post-modal">

                        <div className="map-modal">
                            <img src={images.mapModal} alt="mapModal" />
                        </div>

                    </div>



                </div>
            </Modal>

            <Modal
                title=""
                className="modal-update create-modal"
                centered
                visible={modal3Open}
                closable={true}
                onCancel={() => setModal3Open(false)}
                footer={false}
                width={600}  >
                <div className="add-user-popup">
                    <div className="modal-add-user things-people">
                        <h1>Core Values</h1>
                    </div>

                    <div className="p-5">
                        <div className="px-8">
                            <CoreValueGraph data={coreValueData_Correction} />
                        </div>
                    </div>
                </div>
            </Modal>
        </div >
    )
}
export default Users

